
import { useEffect, useState } from "react";
import useAuthentication from "./Service/hooks/useAuthentication";
import LoginForm from "./Component/LoginForm";
import TOTPForm from "./Component/TOTPForm";
import useSearchParams from "../../hooks/useSearchParams";
import PasskeyRegistrationMessage from "./Component/PasskeyRegistrationMessage";
import AuthenticationService from "../Authentication/Service";
import AuthenticationMenu from "../../Components/AuthenticationMenu";

function composeLoginToken(searchParams) {
    let sid = searchParams.get('sid');
    let id = searchParams.get('id');
    let ip = searchParams.get('ip');
    let sig = searchParams.get('sig');
    let exp = searchParams.get('exp');
    let por = searchParams.get('por');
    if(id && ip && sig && exp && por && sid) {
        return {
            id, ip, sig, exp, por, sid
        }
    }
    return null;
}

function useAuthenticationLogic() {

    const { authenticated, checkCredentials, authenticationMethod, setupRequired, progressive, hasPasskey } = useAuthentication();
    const searchParams = useSearchParams();

    useEffect(() => {
        checkCredentials(composeLoginToken(searchParams));
      
    }, []);

    useEffect(() => {
        if(searchParams.get('pwasetup') === 'load') {
            AuthenticationService.registerAsPWA();
         }
    }, [searchParams.get('pwasetup')]);

    return {
        authenticated, authenticationMethod, setupRequired, progressive, hasPasskey
    }

}


const authenticationMethods = {
    'login': LoginForm,
    'totp': TOTPForm
}


export default function Authentication({ children, portalLabel = 'portaal' }) {
    const { authenticated, authenticationMethod, setupRequired, progressive, hasPasskey } = useAuthenticationLogic();
    const [skipPasscode, setSkipPasscode] = useState(false);
    const AuthenticationMethod = authenticationMethods[authenticationMethod] || LoginForm;
    const onSkipPasscode = () => {
        setSkipPasscode(true);
    }
    if(!authenticated) {
        return <AuthenticationLayout portalLabel={portalLabel}>
            <AuthenticationMenu />  
            <AuthenticationMethod setupRequired={setupRequired} />
        </AuthenticationLayout>;
    }
    if(!skipPasscode && !hasPasskey && progressive) {
        return <AuthenticationLayout portalLabel={portalLabel}>
             <AuthenticationMenu />  
            <PasskeyRegistrationMessage onCancel={onSkipPasscode} />
        </AuthenticationLayout>
    }
    return children;
}

function AuthenticationLayout({ children, portalLabel = 'portaal' }) {


    return <div className="w-screen h-screen bg-[rgb(245,239,224)] flex flex-col items-center justify-center gap-8">
        <div className="w-72">
            <img className="w-full" src="https://u-staat-centraal.nl/wp-content/uploads/2020/10/ustaatcentraal_logo-1.svg" />
        </div>
        <div className="w-96 bg-white p-8 flex flex-col gap-4">
            <div className="flex flex-col gap-1">
                <h1 className="text-2xl font-bold text-center text-[#3A194A]">Zorgconnect {portalLabel} <span className="text-[#666] text-xs">V 2.0.1</span></h1>
                {/* <AuthenticationMenu menuOptions={menuOptions} menuActions={menuActions}/> */}
            </div>

            {children}

        </div>
    </div>


}